module.exports = function phoneIsValid(value) {
    if ("" === value) {
        return true;
    }
    if (/[^0-9\.\-].*/.test(value)) {
        return false;
    }
    return true;
};